import { showHoverTip, hideHoverTip, updateHoverTipText } from "./hoverTipPopup";

// v-hover-tip="text" (optional v-hover-tip:bottom): Klartext-Mouseover statt title-Attribut.
// Leerer Text zeigt nichts.
export default {
  bind(el, binding) {
    const state = {
      text: binding.value,
      enter: () => {
        if (state.text == null || state.text === "") return;
        showHoverTip(el, { text: String(state.text), placement: binding.arg || "top" });
      },
      leave: () => hideHoverTip(el),
    };
    el._hoverTip = state;
    el.addEventListener("mouseenter", state.enter);
    el.addEventListener("mouseleave", state.leave);
  },
  update(el, binding) {
    if (binding.value === binding.oldValue) return;
    el._hoverTip.text = binding.value;
    if (binding.value == null || binding.value === "") hideHoverTip(el);
    else updateHoverTipText(el, String(binding.value));
  },
  unbind(el) {
    const state = el._hoverTip;
    if (!state) return;
    el.removeEventListener("mouseenter", state.enter);
    el.removeEventListener("mouseleave", state.leave);
    hideHoverTip(el);
    delete el._hoverTip;
  },
};
